import React, {Component} from 'react';
import './css/App.css';
import './css/LocationManagement.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppRouter from './routers/AppRouter.js';
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

const muiTheme = getMuiTheme({
    fontFamily: 'Nunito, sans-serif',
    palette: {
        primary1Color: "#1c5c7f",
        accent1Color: "#53c9e8"
    }
});

class App extends Component {
    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="App">
                    <AppRouter location={this.props.location} />
                </div>
            </MuiThemeProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js